// ActiveDashboardContext.js - context terpisah untuk hindari circular import
import { createContext, useContext } from 'react';

export const ActiveDashboardContext = createContext('');

export function useActiveDashboard() {
  return useContext(ActiveDashboardContext);
}
